import { Component, OnInit } from '@angular/core';
//requires tsconfig compiler option "resolveJsonModule": true
import VersionInfo from 'src/assets/version.json';

@Component({
  selector: 'wl-footer',
  templateUrl: 'footer.component.html',
  styleUrls: ['footer.component.less'],
  standalone: false,
})
export class FooterComponent implements OnInit {
  public appVersion: string;
  public currentYear: number = new Date().getFullYear();

  public constructor() {}

  ngOnInit() {
    this.appVersion = VersionInfo.version;
  }
}
